/** Matches {@link scopedPanelSlideInClassName} `duration-300` and sheet motion. */
export const SCOPED_PANEL_TRANSITION_DURATION_MS = 300;

/** Stacking inside map content stage (below viewport-fixed panels). */
export const SCOPED_PANEL_MAP_DIM_Z_INDEX = 48;
/** Previewer map settings / review-notes — below map dim (48), above map tiles. */
export const SCOPED_PANEL_MAP_PREVIEWER_CHROME_Z_INDEX = 47;
/** Edge vignette — above panned map content, below previewer chrome and dim. */
export const SCOPED_PANEL_MAP_VIGNETTE_Z_INDEX = 15;
export const SCOPED_PANEL_MAP_SPOTLIGHT_Z_INDEX = 55;
/** Character path tile on spotlight route (above dimmed route tiles at 55). */
export const SCOPED_PANEL_MAP_SPOTLIGHT_ACTIVE_PATH_TILE_Z_INDEX = 56;
/** Path tile → stop icon → character → player pin → speech bubble (above dim overlay). */
export const SCOPED_PANEL_MAP_SPOTLIGHT_STOP_ICON_Z_INDEX = 56;
export const SCOPED_PANEL_MAP_SPOTLIGHT_CHARACTER_Z_INDEX = 57;
export const SCOPED_PANEL_MAP_SPOTLIGHT_CHARACTER_PIN_Z_INDEX = 58;
export const SCOPED_PANEL_MAP_SPOTLIGHT_SPEECH_Z_INDEX = 59;

/** Stacking on the map host column (panels above the hex map root). */
export const SCOPED_PANEL_HOST_Z_INDEX = 60;
export const SCOPED_PANEL_PANEL_Z_INDEX = 61;

export const SCOPED_PANEL_SPOTLIGHT_DATA_ATTR = "data-scoped-panel-spotlight";

/** Matches default Radix / org sheet overlay tone. */
export const scopedPanelOverlayClassName = "bg-background/80 backdrop-blur-xs";

/** Opacity fade for the map dim layer — keep in sync with sheet transition timing. */
export const scopedPanelMapOverlayFadeClassName =
	"transition-opacity ease-in-out duration-300";

/** Spotlight helpers only — z-index is applied inline so position is unchanged. */
export const scopedPanelSpotlightClassName = "[filter:none]";

/** AppWrapper shell container (`org-app-shell`) — compact panels match main content width. */
export const SCOPED_PANEL_CONTAINER_NAME = "org-app-shell";

/** Above panel slots so overlay nav stays clickable. */
export const SCOPED_PANEL_OVERLAY_NAV_Z_INDEX = 62;

/** Topic learner swiper inner nav orb (64px). */
export const SCOPED_PANEL_OVERLAY_NAV_BUTTON_PX = 64;
